import type { IntlShape } from "react-intl";

export type Msg = { id: string; defaultMessage: string };

export const tx =
  (intl: IntlShape) =>
  (m: Msg, vars?: Record<string, string | number | boolean | null | undefined>): string =>
    intl.formatMessage(m, vars);
